import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { GadgetPlaform, PlatformIcon } from "./GadgetPlaform";
import styles from "../css/GadgetFilter.module.css";
import { capitalizeFirstLetter } from "../../../../helper/utils";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

interface GadgetFilterProps {
  platform: GadgetPlaform;
}

export const GadgetFilter = ({platform}: GadgetFilterProps) => {
  const navigate = useNavigate();
  const [currentPlatform, setCurrentPlatform] = useState<GadgetPlaform>(platform);
  const handleChange = (event: SelectChangeEvent) => {
    const platform = event.target.value as GadgetPlaform;
    setCurrentPlatform(platform);
    navigate(`/platform/${platform}`);
  };

  return (
    <FormControl 
      data-testid="gadget-filter" 
      size="small"
      className={styles.selectBoxContainer}
    >
      <Select
        labelId="gadget-filter"
        id="gadget-filter-select"
        value={currentPlatform}
        onChange={handleChange}
        className={styles.selectBox}
      >
        {
          Object.values(GadgetPlaform).map((item) => 
            <MenuItem
              key={item} 
              value={item}
              className={styles.selectBoxItem}
            >
              <PlatformIcon platform={item} size="sm" style={{marginRight: "5px"}}/>
              {capitalizeFirstLetter(item)}
            </MenuItem>)
        }
      </Select>
    </FormControl>
  );
};
